import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/style.bundle.css'
import './assets/plugins/global/plugins.bundle.css'
import './assets/media/fonts/fiducia.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
const body = document.body;
body.setAttribute("data-bs-theme", "light");
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
